// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboPrices_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/combo_prices/salvar
 * (controllers/so/combo_prices.php::salvar).
 *
 * Cria ou atualiza o preco de UM combo em UMA franquia (Full e Franqueado).
 *   - so_combo_price_combo_id (int, OBRIGATORIO)
 *   - so_combo_price_price    (int, OBRIGATORIO — unidades menores x100 da
 *     moeda local, como ServicePriorities_SalvarInput)
 *   - so_combo_price_id       (int, opcional — presente = update; a franquia
 *     sai do REGISTRO, nunca do corpo)
 *   - so_combo_price_franchise_id (int, exigido na criacao)
 *   - so_combo_price_active   (int 0|1, opcional)
 */
import { registerContract } from './validate'

export interface ComboPrices_SalvarInput {
so_combo_price_combo_id: number
so_combo_price_price: number
so_combo_price_id?: number
so_combo_price_franchise_id?: number
so_combo_price_active?: number
}

registerContract('ComboPrices_SalvarInput', {
  so_combo_price_combo_id:     { type: 'number',  required: true },
  so_combo_price_price:        { type: 'number',  required: true },
  so_combo_price_id:           { type: 'number',  required: false },
  so_combo_price_franchise_id: { type: 'number',  required: false },
  so_combo_price_active:       { type: 'number',  required: false },
})
